import { useEffect, useRef, useState } from "react";

export function useFixedFooter(children: React.ReactNode, pageRef?: React.RefObject<HTMLDivElement | null>) {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    const currentPageRef = pageRef?.current;
    
    const updateFooterHeight = () => {
      if (footerRef.current) {
        const height = footerRef.current.offsetHeight;
        setFooterHeight(height);
        
        // eslint-disable-next-line react-hooks/immutability
        const targetElement = currentPageRef || document.body;
        targetElement.style.paddingBottom = `${height}px`;
      }
    };

    updateFooterHeight();

    const resizeObserver = new ResizeObserver(updateFooterHeight);
    if (footerRef.current) {
      resizeObserver.observe(footerRef.current);
    }

    return () => {
      const targetElement = currentPageRef || document.body;
      targetElement.style.paddingBottom = "";
      resizeObserver.disconnect();
    };
  }, [children, pageRef]);

  return { footerRef, footerHeight };
}
